import React from "react"

import { NetworkAdUnit } from "./styles"

const TopAd = ({ article, ...props }) => {
  const { nsfw } = article

  return <NetworkAdUnit unitName="Mobile_Leaderboard" nsfw={nsfw} hideTitle {...props} />
}

export default TopAd
